// OneDrive:IgnoreCodeCoverage

export const enum PresenceType {
    Unknown = 0,
    Online = 1,
    Busy = 2,
    DoNotDisturb = 3,
    BeRightBack = 4,
    Away = 5,
    Offline = 6,
    Hidden = 7
}